<template>
	<BaseLayout :footer-full="true" :vertically-centered="true">
		<main class="container text-align-center">
			<div class="grid-md gutters-300-md">
				<div class="col-8-md col-offset-2-md col-6-lg col-offset-3-lg">
					<h1 class="heading-1 mb-100 mb-200-md">Account Locked</h1>
					<div class="module">
						<div class="module-section">
							<p>
								Your account has been locked out because of multiple failed login attempts. To unlock
								your account, you must reset your password.
							</p>
						</div>
						<div class="module-section">
							<BaseLink class="button button-primary" :link="resetPasswordLink" />
						</div>
					</div>
				</div>
			</div>
		</main>
	</BaseLayout>
</template>

<script setup lang="ts">
import { Link } from 'types/layout';
import { useHead } from '@unhead/vue';

const resetPasswordLink: Link = {
	text: 'Unlock your account',
	router: 'forgot-password'
};

function setup(): void {
	useHead({
		title: 'Account Locked',
		meta: [{ property: 'og:title', content: 'Account Locked' }]
	});
}

setup();
</script>
